export const USER_TYPES = {
  FIRM: 'Firm',
  USER: 'User',
};

export const CATEGORY_LEVEL = ['pub_categoryLevel1', 'pub_categoryLevel2'];
